import React from 'react'

function DeliveryTakeawayCard({ updateMenusData , selectedMenu, menus, setMenus }) {
  const menu_types = [
   
    { type: '1', name: 'TakeAway' },
    { type: '2', name: 'Delivery' },
    { type: '3', name: 'Zomato' },
    { type: '4', name: 'Swiggy' },
  
  ];

  const handleMenuSelection = async(value) => {

    setMenus(menus.map(item => {
      if (selectedMenu.menu_uuid === item.menu_uuid) {
        return { ...item, menu_type: item?.menu_type?.filter(a => a === value).length ? item?.menu_type?.filter(a => a !== value) : [...item.menu_type, value] }
      } else return { ...item, menu_type: item?.menu_type?.filter(a => a === value).length ? item?.menu_type?.filter(a => a !== value) : [...item.menu_type] }
    }))
    let RECON_TIME = new Date().getTime().toString()
    await updateMenusData(menus.map(item => {
      if (selectedMenu.menu_uuid === item.menu_uuid) {
        return { ...item, menu_type: item?.menu_type?.filter(a => a === value).length ? item?.menu_type?.filter(a => a !== value) : [...item.menu_type, value], RECON_TIME}
      } else return { ...item, menu_type: item?.menu_type?.filter(a => a === value).length ? item?.menu_type?.filter(a => a !== value) : [...item.menu_type], RECON_TIME}
    }))
  };

  return (
    <div
      className="content" id="orders_container"
      style={{ margin: "20px 20px 0 20px" }}
    >
      {
        menu_types.map((menuType) => {


          return <div className={`card-focus rounded`} key={menuType.type} onClick={() => handleMenuSelection(menuType.type)}>
            <div className={`card rounded`}>
              <p className="caption">+</p>
              <p className="title2" style={{ marginBottom: '15px' }}>{menuType.name}</p>
              <div className={`horizontal-line ${menus?.find(a => a.menu_uuid === selectedMenu.menu_uuid)?.menu_type?.filter(o => o === menuType.type
              ).length ? 'red' : ""}`}></div>
            </div>
          </div>
        })
      }
    </div>
  )
}

export default DeliveryTakeawayCard